import React from "react";
import { Spinner } from "./Spinner";
import { Divider } from "@mui/material";

type CardProps = {
    children: React.ReactNode;
    className?: string;
    bodyClassName?: string;
    title?: React.ReactNode;
    isLoading?: boolean;
    centerContext?: boolean;
}

export const Card = ({ children, className, bodyClassName, title, isLoading, centerContext }: CardProps) => {
    return (
      <div
        className={`bg-white shadow-lg rounded-2xl md:rounded-3xl py-10 px-6 sm:px-10 md:px-16 lg:px-24 xl:px-36 min-h-[400px]`}>
          <section className={`${centerContext ? "text-center" : "text-left"} ${className}`}>
              {title && (
                <h2 className="text-xl sm:text-2xl font-bold mb-6 text-gray-800">
                    {title}
                </h2>
              )}
              {isLoading ? <Spinner className="mt-20" size={40} /> :
                <div className={`${centerContext ? "w-full" : "w-full md:w-2/3"} ${bodyClassName}`}>{children}</div>}
          </section>
      </div>
    )
};

type CardBodyProps = {
    children: React.ReactNode;
    className?: string;
    bodyClassName?: string;
    title?: string;
    isLoading?: boolean;
}

Card.Body = ({ children, className, bodyClassName, title, isLoading }: CardBodyProps) => {
    return (
      <div
        className={`py-10 min-h-[400px] ${className}`}>
          {title && (
            <p className="text-lg sm:text-lg font-bold text-gray-800">
                {title}
            </p>
          )}
          <Divider />
          <section className={`w-full mx-auto text-left mt-8 space-y-5 ${bodyClassName}`}>
              {isLoading ? <Spinner className="mt-10" size={40} /> : children}
          </section>
      </div>
    );
};
